export abstract class Webgl2Tool {
  // Life cycle
  public onAssign?(): void;

  public onUnAssign?(): void;

  // Note: onMouseDown and onTouchStart may return "void | false" value,
  // If method returns false, that means that following events won't be tracked (e.g. move, up\end, etc.)
  // Mouse Events
  public onMouseDown?(e: MouseEvent): void | false; // see note above

  public onMouseMove?(e: MouseEvent): void;

  public onMouseUp?(e: MouseEvent): void;

  public onMouseEnter?(e: MouseEvent): void;

  public onMouseOver?(e: MouseEvent): void;

  public onMouseLeave?(e: MouseEvent): void;

  public onMouseCanceled?(e: MouseEvent): void;

  public onMouseEnded?(e: MouseEvent): void;

  // Touch Events
  public onTouchStart?(e: TouchEvent): void | false; // see note above

  public onTouchMove?(e: TouchEvent): void;

  public onTouchEnd?(e: TouchEvent): void;

  public onTouchCanceled?(e: TouchEvent): void;

  public onTouchEnded?(e: TouchEvent): void;
}
